import { Globe } from "lucide-react";
import { useState } from "react";
import type { PublishingPlatform } from "~/core/api/distribution";

export function PlatformIdentity({ platform }: { platform: PublishingPlatform }) {
	const [failed, setFailed] = useState(false);
	const src = platform.logo_url || (platform.domain ? `https://${platform.domain}/favicon.ico` : null);
	return (
		<span className="platform-identity">
			{src && !failed ? (
				<img
					className="platform-icon"
					src={src}
					alt=""
					loading="lazy"
					referrerPolicy="no-referrer"
					onError={() => setFailed(true)}
				/>
			) : (
				<Globe className="platform-icon" aria-hidden="true" />
			)}
			<span>{platform.name}</span>
		</span>
	);
}
